import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 30000 }
  }

  connect() {
    this.startPolling()
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
  }

  disconnect() {
    this.stopPolling()
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopPolling()
    } else {
      this.poll()
      this.startPolling()
    }
  }

  startPolling() {
    this.stopPolling()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  poll() {
    if (!this.element.hasAttribute("src")) {
      this.element.setAttribute("src", this.urlValue)
    } else {
      this.element.reload()
    }
  }

  highlightNewCompletions(event) {
    const oldCompleted = new Set(
      [...this.element.querySelectorAll(".step-complete[data-task-id]")]
        .map(el => el.dataset.taskId)
    )

    const newFrame = event.detail.newFrame
    newFrame.querySelectorAll(".step-complete[data-task-id]").forEach(el => {
      if (!oldCompleted.has(el.dataset.taskId)) {
        el.classList.add("step-just-completed")
      }
    })
  }
}
